import type { Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/finally';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import searchBoards from '../../services/search-boards/index.tsx';
import { SEARCH_CHANGED, searchSuccess, searchFailure } from '../../state/actions.tsx';
import { getLocationType, getBaseUrl, getSearchValue } from '../../state/selectors.tsx';
import type { State } from '../../state/types.tsx';
import locationKeyProvider from '../common/location-key-provider/index.tsx';

export const ERROR = 'navigation-apps.scope-switcher-v2.search-boards';
export const browserMetricsKey = 'navigation-apps.scope-switcher-v2.browser-metrics.search-boards';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const searchBoardsEpic: Epic<any, State> = (action$, store) =>
	action$
		.ofType(SEARCH_CHANGED)
		.filter(({ payload: value }) => !!value.length)
		.mergeMap(() => {
			const searchBoards$ = (locationKey: string) => {
				const state = store.getState();

				const baseUrl = getBaseUrl(state);
				const search = getSearchValue(state);
				const locationType = getLocationType(state);

				const searchBoardsPromise = Promise.all([
					searchBoards(baseUrl, search, locationType, locationKey),
					searchBoards(baseUrl, search, locationType, locationKey, true),
				]);

				return Observable.fromPromise(searchBoardsPromise) // eslint-disable-next-line @typescript-eslint/no-explicit-any
					.map(([searchedBoardsInLocation, searchedBoardsNotInLocation]: [any, any]) =>
						searchSuccess(searchedBoardsInLocation, searchedBoardsNotInLocation),
					)
					.catch((error) => {
						log.safeErrorWithoutCustomerData(ERROR, error.message, error);
						return Observable.of(searchFailure());
					});
			};

			return locationKeyProvider(store, searchBoards$, (errorMessage) => {
				log.safeErrorWithoutCustomerData(ERROR, errorMessage);
				return searchFailure();
			});
		});
